import { accountIsOrganization, accountIsUser, isOrganizationUid, accountIsEnterprise, } from "@buildwithflux/models";
/**
 * Returns whether an account is verified based on the `verified` field from the Firestore document.
 */
export function isVerifiedAccount(verified) {
    return !!verified;
}
export function accountPrivateMetadataIsFromOrganization(accountPrivateMetadata) {
    return isOrganizationUid(accountPrivateMetadata.uid);
}
export function accountPrivateMetadataIsFromUser(accountPrivateMetadata) {
    return !isOrganizationUid(accountPrivateMetadata.uid);
}
export function getAccountType(account) {
    return accountIsEnterprise(account) ? "enterprise" : accountIsOrganization(account) ? "organization" : "user";
}
export function getAccountDisplayName(account) {
    if (accountIsUser(account)) {
        return account.full_name;
    }
    return account.displayName;
}
export function getAccountProfileBio(account) {
    if (accountIsOrganization(account)) {
        return account.bioContent;
    }
    else {
        return account.tag_line;
    }
}
export function getAccountProjectCount(account) {
    if (accountIsEnterprise(account)) {
        return account.defaultOrganization.documentsCount;
    }
    else if (accountIsOrganization(account)) {
        return account.documentsCount;
    }
    else {
        return account.documents_count;
    }
}
export function getAccountFollowersCount(account) {
    if (accountIsEnterprise(account)) {
        return account.defaultOrganization.follower_count;
    }
    else if (accountIsOrganization(account)) {
        return account.follower_count;
    }
    else {
        return account.follower_count;
    }
}
//# sourceMappingURL=helpers.js.map